/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/*!***************************!*\
  !*** ./demo/src/index.js ***!
  \***************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// demo pages css
	__webpack_require__(/*! normalize.css/normalize.css */ 7);
	__webpack_require__(/*! ./vendor/skeleton.css */ 5);
	__webpack_require__(/*! ./vendor/github.css */ 4);
	__webpack_require__(/*! ./vendor/syntax.css */ 6);
	__webpack_require__(/*! ./vendor/rainbow-custom.min.js */ 2);
	__webpack_require__(/*! ./css/style.scss */ 9);
	
	// css for form field
	__webpack_require__(/*! ./css/demo.scss */ 8);
	
	/*==========  APP  ==========*/
	
	var React = __webpack_require__(/*! react */ 1),
	    InputPassword = __webpack_require__(/*! ../../lib/react-ux-password-field.js */ 3);
	
	React.render(React.createElement(
	  'form',
	  null,
	  React.createElement(
	    'fieldset',
	    null,
	    React.createElement(
	      'label',
	      { htmlFor: 'password1' },
	      'Password'
	    ),
	    React.createElement(InputPassword, {
	      id: 'password1',
	      name: 'password1',
	      placeholder: 'Try me out!  Enter a random password.',
	      minScore: 1,
	      minLength: 5,
	      zxcvbn: 'debug'
	    })
	  )
	), document.getElementById('content'));

/***/ },
/* 1 */
/*!************************!*\
  !*** external "React" ***!
  \************************/
/***/ function(module, exports) {

	module.exports = React;

/***/ },
/* 2 */
/*!***********************************************!*\
  !*** ./demo/src/vendor/rainbow-custom.min.js ***!
  \***********************************************/
/***/ function(module, exports) {

	/* Rainbow v1.2 rainbowco.de | included languages: generic, shell, javascript, html */
	"use strict";
	
	window.Rainbow = (function () {
	  function q(a) {
	    var b,
	        c = a.getAttribute && a.getAttribute("data-language") || 0;if (!c) {
	      a = a.attributes;for (b = 0; b < a.length; ++b) if ("data-language" === a[b].nodeName) return a[b].nodeValue;
	    }return c;
	  }function B(a) {
	    var b = q(a) || q(a.parentNode);if (!b) {
	      var c = /\blang(?:uage)?-(\w+)/;(a = a.className.match(c) || a.parentNode.className.match(c)) && (b = a[1]);
	    }return b;
	  }function C(a, b) {
	    for (var c in f[d]) {
	      c = parseInt(c, 10);if (a == c && b == f[d][c] ? 0 : a <= c && b >= f[d][c]) delete f[d][c], delete j[d][c];if (a >= c && a < f[d][c] || b > c && b < f[d][c]) return !0;
	    }return !1;
	  }function r(a, b) {
	    return '<span class="' + a.replace(/\./g, " ") + (l ? " " + l : "") + '">' + b + "</span>";
	  }function s(a, b, c, i) {
	    if ("undefined" === typeof a || null === a) i();else {
	      var e = a.exec(c);if (e) {
	        ++t;!b.name && "string" == typeof b.matches[0] && (b.name = b.matches[0], delete b.matches[0]);var k = e[0],
	            g = e.index,
	            u = e[0].length + g,
	            h = function h() {
	          function e() {
	            s(a, b, c, i);
	          }t % 100 > 0 ? e() : setTimeout(e, 0);
	        };if (C(g, u)) h();else {
	          var m = v(b.matches),
	              l = function l(a, c, i) {
	            if (a >= c.length) i(k);else {
	              var d = e[c[a]];if (d) {
	                var g = b.matches[c[a]],
	                    f = g.language,
	                    h = g.name && g.matches ? g.matches : g,
	                    j = function j(b, d, g) {
	                  var f;f = 0;var h;for (h = 1; h < c[a]; ++h) e[h] && (f = f + e[h].length);d = g ? r(g, d) : d;k = k.substr(0, f) + k.substr(f).replace(b, d);l(++a, c, i);
	                };f ? n(d, f, function (a) {
	                  j(d, a);
	                }) : typeof g === "string" ? j(d, d, g) : w(d, h.length ? h : [h], function (a) {
	                  j(d, a, g.matches ? g.name : 0);
	                });
	              } else l(++a, c, i);
	            }
	          };l(0, m, function (a) {
	            b.name && (a = r(b.name, a));if (!j[d]) {
	              j[d] = {};f[d] = {};
	            }j[d][g] = { replace: e[0], "with": a };f[d][g] = u;h();
	          });
	        }
	      } else i();
	    }
	  }function v(a) {
	    var b = [],
	        c;for (c in a) a.hasOwnProperty(c) && b.push(c);return b.sort(function (a, b) {
	      return b - a;
	    });
	  }function w(a, b, c) {
	    function i(b, k) {
	      k < b.length ? s(b[k].pattern, b[k], a, function () {
	        i(b, ++k);
	      }) : D(a, function (a) {
	        delete j[d];delete f[d];--d;c(a);
	      });
	    }++d;i(b, 0);
	  }function D(a, b) {
	    function c(a, b, i, f) {
	      if (i < b.length) {
	        ++x;var h = b[i],
	            l = j[d][h],
	            a = a.substr(0, h) + a.substr(h).replace(l.replace, l["with"]),
	            h = function h() {
	          c(a, b, ++i, f);
	        };0 < x % 250 ? h() : setTimeout(h, 0);
	      } else f(a);
	    }var i = v(j[d]);c(a, i, 0, b);
	  }function n(a, b, c) {
	    var d = m[b] || [],
	        e = m[y] || [],
	        b = z[b] ? d : d.concat(e);w(a.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/&(?![\w\#]+;)/g, "&amp;"), b, c);
	  }function o(_x, _x2, _x3) {
	    var _again = true;
	
	    _function: while (_again) {
	      var a = _x,
	          b = _x2,
	          c = _x3;
	      _again = false;
	      if (b < a.length) {
	        var d = a[b],
	            e = B(d);if (!(-1 < (" " + d.className + " ").indexOf(" rainbow ")) && e) {
	          return e = e.toLowerCase(), d.className += d.className ? " rainbow" : "rainbow", n(d.innerHTML, e, function (k) {
	            d.innerHTML = k;j = {};f = {};p && p(d, e);setTimeout(function () {
	              o(a, ++b, c);
	            }, 0);
	          });
	        } else {
	          _x = a;
	          _x2 = ++b;
	          _x3 = c;
	          _again = true;
	          d = e = undefined;
	          continue _function;
	        }
	      }c && c();
	    }
	  }function A(a, b) {
	    var a = a && "function" == typeof a.getElementsByTagName ? a : document,
	        c = a.getElementsByTagName("pre"),
	        d = a.getElementsByTagName("code"),
	        e,
	        f = [],
	        g = [];for (e = 0; e < c.length; ++e) c[e].getElementsByTagName("code").length ? c[e].innerHTML = c[e].innerHTML.replace(/^\s+/, "").replace(/\s+$/, "") : f.push(c[e]);for (e = 0; e < d.length; ++e) g.push(d[e]);o(g.concat(f), 0, b);
	  }var j = {},
	      f = {},
	      m = {},
	      z = {},
	      d = 0,
	      y = 0,
	      t = 0,
	      x = 0,
	      l,
	      p;return { extend: function extend(a, b, c) {
	      1 == arguments.length && (b = a, a = y);z[a] = c;m[a] = b.concat(m[a] || []);
	    }, b: function b(a) {
	      p = a;
	    }, a: function a(_a) {
	      l = _a;
	    }, color: function color(a, b, c) {
	      if ("string" == typeof a) return n(a, b, c);if ("function" == typeof a) return A(0, a);A(a, b);
	    } };
	})();
	document.addEventListener ? document.addEventListener("DOMContentLoaded", Rainbow.color, !1) : window.attachEvent("onload", Rainbow.color);Rainbow.onHighlight = Rainbow.b;Rainbow.addClass = Rainbow.a;Rainbow.extend([{ matches: { 1: [{ name: "keyword.operator", pattern: /\=|\+/g }, { name: "keyword.dot", pattern: /\./g }], 2: { name: "string", matches: { name: "constant.character.escape", pattern: /\\('|"){1}/g } } }, pattern: /(\(|\s|\[|\=|:|\+|\.)(('|")([^\\\1]|\\.)*?(\3))/gm }, { name: "comment", pattern: /\/\*[\s\S]*?\*\/|(\/\/|\#)[\s\S]*?$/gm }, { name: "constant.numeric", pattern: /\b(\d+(\.\d+)?(e(\+|\-)?\d+)?(f|d)?|0x[\da-f]+)\b/gi }, { matches: { 1: "keyword" }, pattern: /\b(and|array|as|b(ool(ean)?|reak)|c(ase|atch|har|lass|on(st|tinue))|d(ef|elete|o(uble)?)|e(cho|lse(if)?|xit|xtends|xcept)|f(inally|loat|or(each)?|unction)|global|if|import|int(eger)?|long|new|object|or|pr(int|ivate|otected)|public|return|self|st(ring|ruct|atic)|switch|th(en|is|row)|try|(un)?signed|var|void|while)(?=\(|\b)/gi }, { name: "constant.language", pattern: /true|false|null/g }, { name: "keyword.operator", pattern: /\+|\!|\-|&(gt|lt|amp);|\||\*|\=/g }, { matches: { 1: "function.call" }, pattern: /(\w+?)(?=\()/g }, { matches: { 1: "storage.function", 2: "entity.name.function" }, pattern: /(function)\s(.*?)(?=\()/g }]);Rainbow.extend("shell", [{ name: "shell", matches: { 1: { language: "shell" } }, pattern: /\$\(([\s\S]*?)\)/gm }, { matches: { 2: "string" }, pattern: /(\(|\s|\[|\=)(('|")[\s\S]*?(\3))/gm }, { name: "keyword.operator", pattern: /&lt;|&gt;|&amp;/g }, { name: "comment", pattern: /\#[\s\S]*?$/gm }, { name: "storage.function", pattern: /(.+?)(?=\(\)\s{0,}\{)/g }, { name: "support.command", pattern: /\b(echo|rm|ls|(mk|rm)dir|cd|find|cp|exit|pwd|exec|trap|source|shift|unset)/g }, { matches: { 1: "keyword" }, pattern: /\b(break|case|continue|do|done|elif|else|esac|eval|export|fi|for|function|if|in|local|return|set|then|unset|until|while)(?=\(|\b)/g }], !0);Rainbow.extend("javascript", [{ name: "selector", pattern: /(\s|^)\$(?=\.|\()/g }, { name: "support", pattern: /\b(window|document)\b/g }, { matches: { 1: "support.property" }, pattern: /\.(length|node(Name|Value))\b/g }, { matches: { 1: "support.function" }, pattern: /(setTimeout|setInterval)(?=\()/g }, { matches: { 1: "support.method" }, pattern: /\.(getAttribute|push|getElementById|getElementsByClassName|log|setTimeout|setInterval)(?=\()/g }, { name: "string.regexp", matches: { 1: "string.regexp.open", 2: { name: "constant.regexp.escape", pattern: /\\(.){1}/g },
	    3: "string.regexp.close", 4: "string.regexp.modifier" }, pattern: /(\/)(?!\*)(.+)(\/)([igm]{0,3})/g }, { matches: { 1: "storage", 3: "entity.function" }, pattern: /(var)?(\s|^)(\S*)(?=\s?=\s?function\()/g }, { matches: { 1: "keyword", 2: "entity.function" }, pattern: /(new)\s+(.*)(?=\()/g }, { name: "entity.function", pattern: /(\w+)(?=:\s{0,}function)/g }]);Rainbow.extend("html", [{ name: "source.php.embedded", matches: { 2: { language: "php" } }, pattern: /&lt;\?=?(?!xml)(php)?([\s\S]*?)(\?&gt;)/gm }, { name: "source.css.embedded", matches: { 1: { matches: { 1: "support.tag.style", 2: [{ name: "entity.tag.style", pattern: /^style/g }, { name: "string", pattern: /('|")(.*?)(\1)/g }, { name: "entity.tag.style.attribute", pattern: /(\w+)/g }], 3: "support.tag.style" }, pattern: /(&lt;\/?)(style.*?)(&gt;)/g }, 2: { language: "css" }, 3: "support.tag.style", 4: "entity.tag.style", 5: "support.tag.style" }, pattern: /(&lt;style.*?&gt;)([\s\S]*?)(&lt;\/)(style)(&gt;)/gm }, { name: "source.js.embedded", matches: { 1: { matches: { 1: "support.tag.script", 2: [{ name: "entity.tag.script", pattern: /^script/g }, { name: "string", pattern: /('|")(.*?)(\1)/g }, { name: "entity.tag.script.attribute", pattern: /(\w+)/g }], 3: "support.tag.script" }, pattern: /(&lt;\/?)(script.*?)(&gt;)/g }, 2: { language: "javascript" }, 3: "support.tag.script", 4: "entity.tag.script", 5: "support.tag.script" }, pattern: /(&lt;script(?! src).*?&gt;)([\s\S]*?)(&lt;\/)(script)(&gt;)/gm }, { name: "comment.html", pattern: /&lt;\!--[\S\s]*?--&gt;/g }, { matches: { 1: "support.tag.open", 2: "support.tag.close" }, pattern: /(&lt;)|(\/?\??&gt;)/g }, { name: "support.tag", matches: { 1: "support.tag", 2: "support.tag.special", 3: "support.tag-name" }, pattern: /(&lt;\??)(\/|\!?)(\w+)/g }, { matches: { 1: "support.attribute" }, pattern: /([a-z-]+)(?=\=)/gi }, { matches: { 1: "support.operator", 2: "string.quote", 3: "string.value", 4: "string.quote" }, pattern: /(=)('|")(.*?)(\2)/g }, { matches: { 1: "support.operator", 2: "support.value" }, pattern: /(=)([a-zA-Z\-0-9]*)\b/g }, { matches: { 1: "support.attribute" },
	  pattern: /\s(\w+)(?=\s|&gt;)(?![\s\S]*&lt;)/g }], !0);

/***/ },
/* 3 */
/*!****************************************!*\
  !*** ./lib/react-ux-password-field.js ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * React UX Password Field
	 * version: 0.9.12
	 * 
	 * MIT Licensed
	 * github: https://github.com/seethroughtrees/react-ux-password-field/
	 * demo: https://seethroughtrees.github.io/react-ux-password-field/
	 * 
	 */
	'use strict';
	
	(function webpackUniversalModuleDefinition(root, factory) {
		if (true) module.exports = factory(__webpack_require__(/*! react */ 1));else if (typeof define === 'function' && define.amd) define(["react"], factory);else if (typeof exports === 'object') exports["react-ux-password-field"] = factory(require("react"));else root["react-ux-password-field"] = factory(root["React"]);
	})(undefined, function (__WEBPACK_EXTERNAL_MODULE_1__) {
		return (/******/(function (modules) {
				// webpackBootstrap
				/******/ // The module cache
				/******/var installedModules = {};
	
				/******/ // The require function
				/******/function __webpack_require__(moduleId) {
	
					/******/ // Check if module is in cache
					/******/if (installedModules[moduleId])
						/******/return installedModules[moduleId].exports;
	
					/******/ // Create a new module (and put it into the cache)
					/******/var module = installedModules[moduleId] = {
						/******/exports: {},
						/******/id: moduleId,
						/******/loaded: false
						/******/ };
	
					/******/ // Execute the module function
					/******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
					/******/ // Flag the module as loaded
					/******/module.loaded = true;
	
					/******/ // Return the exports of the module
					/******/return module.exports;
					/******/
				}
	
				/******/ // expose the modules object (__webpack_modules__)
				/******/__webpack_require__.m = modules;
	
				/******/ // expose the module cache
				/******/__webpack_require__.c = installedModules;
	
				/******/ // __webpack_public_path__
				/******/__webpack_require__.p = "";
	
				/******/ // Load entry module and return exports
				/******/return __webpack_require__(0);
				/******/
			})(
			/************************************************************************/
			/******/[
			/* 0 */
			function (module, exports, __webpack_require__) {
	
				'use strict';
	
				var _extends = Object.assign || function (target) {
					for (var i = 1; i < arguments.length; i++) {
						var source = arguments[i];for (var key in source) {
							if (Object.prototype.hasOwnProperty.call(source, key)) {
								target[key] = source[key];
							}
						}
					}return target;
				};
	
				function _objectWithoutProperties(obj, keys) {
					var target = {};for (var i in obj) {
						if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
					}return target;
				}
	
				var React = __webpack_require__(1),
				    RP = React.PropTypes,
				    config = __webpack_require__(2),
				    debounce = __webpack_require__(3);
	
				var InputPassword = React.createClass({
					displayName: 'InputPassword',
	
					/*==========  VALIDATE  ==========*/
	
					propTypes: {
						infoBar: RP.bool,
						statusColor: RP.string,
						statusInactiveColor: RP.string,
						minScore: RP.number,
						changeCb: RP.func,
						toggleMask: RP.bool,
						unMaskTime: RP.number,
						minLength: RP.number,
						strengthLang: RP.array,
						id: RP.string
					},
	
					/*==========  DEFAULTS  ==========*/
	
					getDefaultProps: function getDefaultProps() {
						return {
							infoBar: true,
							statusColor: config.statusColor,
							statusInactiveColor: config.statusInactiveColor,
							zxcvbn: config.zxcvbnSrc,
							minScore: 0,
							toggleMask: true,
							unMaskTime: config.unMaskTime,
							strengthLang: config.strengthLang,
							id: 'input'
						};
					},
	
					getInitialState: function getInitialState() {
						return {
							value: '',
							score: 0,
							entropy: 0,
							isPassword: true,
							isValid: false
						};
					},
	
					/*==========  STYLES  ==========*/
	
					getMeterStyle: function getMeterStyle(score) {
						var width = this.state.value === '' ? 0 : 24 * score + 4;
						return {
							width: this.props.zxcvbn ? width + '%' : '100%',
							maxWidth: '85%',
							opacity: this.props.zxcvbn ? width * .01 + .5 : '1',
							background: this.state.isValid ? this.props.statusColor : this.props.statusInactiveColor,
							height: 5,
							transition: 'all 400ms linear',
							display: 'inline-block',
							marginRight: '1%'
						};
					},
	
					unMaskStyle: {
						color: config.unMaskColor,
						fontWeight: 200
					},
	
					infoStyle: {
						position: 'absolute',
						bottom: -10,
						width: '100%',
						overflow: 'hidden',
						height: 24
					},
	
					iconStyle: {
						display: 'inline-block',
						opacity: .25,
						position: 'relative',
						top: 2,
						width: '3%'
					},
	
					strengthLangStyle: {
						fontSize: 12,
						position: 'relative',
						top: 2
					},
	
					/*==========  METHODS  ==========*/
	
					addPasswordType: function addPasswordType() {
						this.setState({
							isPassword: true
						});
					},
	
					/*==========  HANDLERS  ==========*/
	
					handleInputType: function handleInputType() {
						this.setState({
							isPassword: !this.state.isPassword
						});
					},
	
					handleChange: function handleChange(e) {
						e.preventDefault();
	
						var native_target = e.nativeEvent.target;
						var val = e.target.value;
						var score;
	
						this.setState({
							value: val,
							isValid: e.target.validity.valid,
							selectionStart: native_target.selectionStart,
							selectionEnd: native_target.selectionEnd
						});
	
						if (this.props.toggleMask) {
							this.handleToggleMask();
						}
	
						if (this.props.zxcvbn) {
							score = this.handleZxcvbn(val);
						} else {
							score = this.state.score;
						}
	
						// call onChange prop passed from parent
						if (this.props.onChange) {
							this.props.onChange(val, this.state.isValid, score);
						}
	
						if (this.props.minLength) {
							this.handleMinLength(e.target.value.length);
						}
					},
	
					handleToggleMask: function handleToggleMask() {
	
						// display password, then
						this.setState({
							isPassword: false
						});
	
						// debounce remasking password
						this.maskPassword();
					},
	
					handleZxcvbn: function handleZxcvbn(val) {
	
						if (typeof zxcvbn === 'undefined' && typeof window.zxcvbn === 'undefined') {
							return;
						}
	
						var stats = zxcvbn(val),
						    currentScore = stats.score;
	
						this.setState({
							score: currentScore,
							entropy: stats.entropy
						});
	
						if (currentScore < this.props.minScore) {
							this.setState({
								isValid: false
							});
						}
	
						// if score changed and callback provided
						if (this.props.changeCb && this.state.score !== currentScore) {
							this.props.changeCb(this.state.score, currentScore, val);
						}
	
						if (this.props.zxcvbn === 'debug') {
							console.debug(stats);
						}
	
						return currentScore;
					},
	
					handleMinLength: function handleMinLength(len) {
						if (len <= this.props.minLength) {
							this.setState({
								isValid: false
							});
						}
					},
	
					componentWillMount: function componentWillMount() {
						var zxcvbnSrc;
	
						// Load zxcvbn async if its enabled and doesn't already exist
						if (this.props.zxcvbn && typeof zxcvbn === 'undefined') {
	
							zxcvbnSrc = this.props.zxcvbn !== 'debug' ? this.props.zxcvbn : config.zxcvbnSrc;
	
							// snippet to async load zxcvbn if enabled
							(function () {
								var a;a = function () {
									var a, b;b = document.createElement("script");b.src = zxcvbnSrc;b.type = "text/javascript";b.async = !0;a = document.getElementsByTagName("head")[0];return a.parentNode.insertBefore(b, a);
								};null != window.attachEvent ? window.attachEvent("onload", a) : window.addEventListener("load", a, !1);
							}).call(this);
						}
	
						// set debouncer for password
						if (this.props.toggleMask) {
							this.maskPassword = debounce(this.addPasswordType, this.props.unMaskTime);
						}
					},
	
					componentWillUnmount: function componentWillUnmount() {
						// cancel the debouncer when component is not used anymore. This to avoid
						// setting the state  unnecessarily, see issue #24
						if (this.maskPassword) {
							this.maskPassword.cancel();
						}
					},
	
					render: function render() {
						var infoBar;
	
						if (this.props.infoBar) {
							infoBar = React.createElement('div', { className: 'passwordField__info', style: this.infoStyle }, React.createElement('span', { style: this.iconStyle, className: 'passwordField__icon' }, React.createElement('img', { src: __webpack_require__(4), height: '10', width: '10' })), React.createElement('span', { style: this.getMeterStyle(this.state.score), className: 'passwordField__meter' }), React.createElement('span', { style: this.strengthLangStyle, className: 'passwordField__strength' }, this.props.zxcvbn && this.state.value.length > 0 && this.props.strengthLang.length > 0 ? this.props.strengthLang[this.state.score] : null));
						}
	
						// allow onChange to be passed from parent and not override default prop
						var _props = this.props;
						var onChange = _props.onChange;
	
						var props = _objectWithoutProperties(_props, ['onChange']);
	
						// overcome problem with firefox resetting the input selection point
						var that = this;
						if (typeof navigator !== 'undefined') {
							setTimeout(function () {
								if (!/Firefox/.test(navigator.userAgent)) return;
								var elem = that.refs[that.props.id].getDOMNode();
								elem.selectionStart = that.state.selectionStart;
								elem.selectionEnd = that.state.selectionEnd;
							}, 1);
						}
	
						return React.createElement('div', {
							style: { position: 'relative', display: 'inline-block' },
							className: 'passwordField',
							'data-valid': this.state.isValid,
							'data-score': this.state.score,
							'data-entropy': this.state.entropy
						}, React.createElement('input', _extends({
							ref: this.props.id,
							className: 'passwordField__input',
							type: this.state.isPassword ? 'password' : 'text',
							value: this.state.value,
							style: this.state.isPassword ? null : this.unMaskStyle,
							onChange: this.handleChange
						}, props)), infoBar);
					}
				});
	
				module.exports = InputPassword;
	
				/***/
			},
			/* 1 */
			function (module, exports) {
	
				module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
	
				/***/
			},
			/* 2 */
			function (module, exports) {
	
				'use strict';
	
				module.exports = {
					statusColor: '#5CE592',
					statusInactiveColor: '#FC6F6F',
					unMaskColor: '#c7c7c7',
					unMaskTime: 1400,
					zxcvbnSrc: 'https://cdnjs.cloudflare.com/ajax/libs/zxcvbn/1.0/zxcvbn.min.js',
					strengthLang: ['Weak', 'Okay', 'Good', 'Strong', 'Great']
				};
	
				/***/
			},
			/* 3 */
			function (module, exports) {
	
				/**
	    * lodash 4.0.6 (Custom Build) <https://lodash.com/>
	    * Build: `lodash modularize exports="npm" -o ./`
	    * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	    * Released under MIT license <https://lodash.com/license>
	    * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	    * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	    */
	
				/** Used as the `TypeError` message for "Functions" methods. */
				'use strict';
	
				var FUNC_ERROR_TEXT = 'Expected a function';
	
				/** Used as references for various `Number` constants. */
				var NAN = 0 / 0;
	
				/** `Object#toString` result references. */
				var funcTag = '[object Function]',
				    genTag = '[object GeneratorFunction]',
				    symbolTag = '[object Symbol]';
	
				/** Used to match leading and trailing whitespace. */
				var reTrim = /^\s+|\s+$/g;
	
				/** Used to detect bad signed hexadecimal string values. */
				var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
				/** Used to detect binary string values. */
				var reIsBinary = /^0b[01]+$/i;
	
				/** Used to detect octal string values. */
				var reIsOctal = /^0o[0-7]+$/i;
	
				/** Built-in method references without a dependency on `root`. */
				var freeParseInt = parseInt;
	
				/** Used for built-in method references. */
				var objectProto = Object.prototype;
	
				/**
	    * Used to resolve the
	    * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	    * of values.
	    */
				var objectToString = objectProto.toString;
	
				/* Built-in method references for those with the same name as other `lodash` methods. */
				var nativeMax = Math.max,
				    nativeMin = Math.min;
	
				/**
	    * Gets the timestamp of the number of milliseconds that have elapsed since
	    * the Unix epoch (1 January 1970 00:00:00 UTC).
	    *
	    * @static
	    * @memberOf _
	    * @since 2.4.0
	    * @type {Function}
	    * @category Date
	    * @returns {number} Returns the timestamp.
	    * @example
	    *
	    * _.defer(function(stamp) {
	    *   console.log(_.now() - stamp);
	    * }, _.now());
	    * // => Logs the number of milliseconds it took for the deferred function to be invoked.
	    */
				var now = Date.now;
	
				/**
	    * Creates a debounced function that delays invoking `func` until after `wait`
	    * milliseconds have elapsed since the last time the debounced function was
	    * invoked. The debounced function comes with a `cancel` method to cancel
	    * delayed `func` invocations and a `flush` method to immediately invoke them.
	    * Provide an options object to indicate whether `func` should be invoked on
	    * the leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	    * with the last arguments provided to the debounced function. Subsequent calls
	    * to the debounced function return the result of the last `func` invocation.
	    *
	    * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	    * on the trailing edge of the timeout only if the debounced function is
	    * invoked more than once during the `wait` timeout.
	    *
	    * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	    * for details over the differences between `_.debounce` and `_.throttle`.
	    *
	    * @static
	    * @memberOf _
	    * @since 0.1.0
	    * @category Function
	    * @param {Function} func The function to debounce.
	    * @param {number} [wait=0] The number of milliseconds to delay.
	    * @param {Object} [options={}] The options object.
	    * @param {boolean} [options.leading=false]
	    *  Specify invoking on the leading edge of the timeout.
	    * @param {number} [options.maxWait]
	    *  The maximum time `func` is allowed to be delayed before it's invoked.
	    * @param {boolean} [options.trailing=true]
	    *  Specify invoking on the trailing edge of the timeout.
	    * @returns {Function} Returns the new debounced function.
	    * @example
	    *
	    * // Avoid costly calculations while the window size is in flux.
	    * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	    *
	    * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	    * jQuery(element).on('click', _.debounce(sendMail, 300, {
	    *   'leading': true,
	    *   'trailing': false
	    * }));
	    *
	    * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	    * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	    * var source = new EventSource('/stream');
	    * jQuery(source).on('message', debounced);
	    *
	    * // Cancel the trailing debounced invocation.
	    * jQuery(window).on('popstate', debounced.cancel);
	    */
				function debounce(func, wait, options) {
					var lastArgs,
					    lastThis,
					    maxWait,
					    result,
					    timerId,
					    lastCallTime = 0,
					    lastInvokeTime = 0,
					    leading = false,
					    maxing = false,
					    trailing = true;
	
					if (typeof func != 'function') {
						throw new TypeError(FUNC_ERROR_TEXT);
					}
					wait = toNumber(wait) || 0;
					if (isObject(options)) {
						leading = !!options.leading;
						maxing = 'maxWait' in options;
						maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
						trailing = 'trailing' in options ? !!options.trailing : trailing;
					}
	
					function invokeFunc(time) {
						var args = lastArgs,
						    thisArg = lastThis;
	
						lastArgs = lastThis = undefined;
						lastInvokeTime = time;
						result = func.apply(thisArg, args);
						return result;
					}
	
					function leadingEdge(time) {
						// Reset any `maxWait` timer.
						lastInvokeTime = time;
						// Start the timer for the trailing edge.
						timerId = setTimeout(timerExpired, wait);
						// Invoke the leading edge.
						return leading ? invokeFunc(time) : result;
					}
	
					function remainingWait(time) {
						var timeSinceLastCall = time - lastCallTime,
						    timeSinceLastInvoke = time - lastInvokeTime,
						    result = wait - timeSinceLastCall;
	
						return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
					}
	
					function shouldInvoke(time) {
						var timeSinceLastCall = time - lastCallTime,
						    timeSinceLastInvoke = time - lastInvokeTime;
	
						// Either this is the first call, activity has stopped and we're at the
						// trailing edge, the system time has gone backwards and we're treating
						// it as the trailing edge, or we've hit the `maxWait` limit.
						return !lastCallTime || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
					}
	
					function timerExpired() {
						var time = now();
						if (shouldInvoke(time)) {
							return trailingEdge(time);
						}
						// Restart the timer.
						timerId = setTimeout(timerExpired, remainingWait(time));
					}
	
					function trailingEdge(time) {
						clearTimeout(timerId);
						timerId = undefined;
	
						// Only invoke if we have `lastArgs` which means `func` has been
						// debounced at least once.
						if (trailing && lastArgs) {
							return invokeFunc(time);
						}
						lastArgs = lastThis = undefined;
						return result;
					}
	
					function cancel() {
						if (timerId !== undefined) {
							clearTimeout(timerId);
						}
						lastCallTime = lastInvokeTime = 0;
						lastArgs = lastThis = timerId = undefined;
					}
	
					function flush() {
						return timerId === undefined ? result : trailingEdge(now());
					}
	
					function debounced() {
						var time = now(),
						    isInvoking = shouldInvoke(time);
	
						lastArgs = arguments;
						lastThis = this;
						lastCallTime = time;
	
						if (isInvoking) {
							if (timerId === undefined) {
								return leadingEdge(lastCallTime);
							}
							if (maxing) {
								// Handle invocations in a tight loop.
								clearTimeout(timerId);
								timerId = setTimeout(timerExpired, wait);
								return invokeFunc(lastCallTime);
							}
						}
						if (timerId === undefined) {
							timerId = setTimeout(timerExpired, wait);
						}
						return result;
					}
					debounced.cancel = cancel;
					debounced.flush = flush;
					return debounced;
				}
	
				/**
	    * Checks if `value` is classified as a `Function` object.
	    *
	    * @static
	    * @memberOf _
	    * @since 0.1.0
	    * @category Lang
	    * @param {*} value The value to check.
	    * @returns {boolean} Returns `true` if `value` is correctly classified,
	    *  else `false`.
	    * @example
	    *
	    * _.isFunction(_);
	    * // => true
	    *
	    * _.isFunction(/abc/);
	    * // => false
	    */
				function isFunction(value) {
					// The use of `Object#toString` avoids issues with the `typeof` operator
					// in Safari 8 which returns 'object' for typed array and weak map constructors,
					// and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
					var tag = isObject(value) ? objectToString.call(value) : '';
					return tag == funcTag || tag == genTag;
				}
	
				/**
	    * Checks if `value` is the
	    * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
	    * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	    *
	    * @static
	    * @memberOf _
	    * @since 0.1.0
	    * @category Lang
	    * @param {*} value The value to check.
	    * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	    * @example
	    *
	    * _.isObject({});
	    * // => true
	    *
	    * _.isObject([1, 2, 3]);
	    * // => true
	    *
	    * _.isObject(_.noop);
	    * // => true
	    *
	    * _.isObject(null);
	    * // => false
	    */
				function isObject(value) {
					var type = typeof value;
					return !!value && (type == 'object' || type == 'function');
				}
	
				/**
	    * Checks if `value` is object-like. A value is object-like if it's not `null`
	    * and has a `typeof` result of "object".
	    *
	    * @static
	    * @memberOf _
	    * @since 4.0.0
	    * @category Lang
	    * @param {*} value The value to check.
	    * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	    * @example
	    *
	    * _.isObjectLike({});
	    * // => true
	    *
	    * _.isObjectLike([1, 2, 3]);
	    * // => true
	    *
	    * _.isObjectLike(_.noop);
	    * // => false
	    *
	    * _.isObjectLike(null);
	    * // => false
	    */
				function isObjectLike(value) {
					return !!value && typeof value == 'object';
				}
	
				/**
	    * Checks if `value` is classified as a `Symbol` primitive or object.
	    *
	    * @static
	    * @memberOf _
	    * @since 4.0.0
	    * @category Lang
	    * @param {*} value The value to check.
	    * @returns {boolean} Returns `true` if `value` is correctly classified,
	    *  else `false`.
	    * @example
	    *
	    * _.isSymbol(Symbol.iterator);
	    * // => true
	    *
	    * _.isSymbol('abc');
	    * // => false
	    */
				function isSymbol(value) {
					return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
				}
	
				/**
	    * Converts `value` to a number.
	    *
	    * @static
	    * @memberOf _
	    * @since 4.0.0
	    * @category Lang
	    * @param {*} value The value to process.
	    * @returns {number} Returns the number.
	    * @example
	    *
	    * _.toNumber(3);
	    * // => 3
	    *
	    * _.toNumber(Number.MIN_VALUE);
	    * // => 5e-324
	    *
	    * _.toNumber(Infinity);
	    * // => Infinity
	    *
	    * _.toNumber('3');
	    * // => 3
	    */
				function toNumber(value) {
					if (typeof value == 'number') {
						return value;
					}
					if (isSymbol(value)) {
						return NAN;
					}
					if (isObject(value)) {
						var other = isFunction(value.valueOf) ? value.valueOf() : value;
						value = isObject(other) ? other + '' : other;
					}
					if (typeof value != 'string') {
						return value === 0 ? value : +value;
					}
					value = value.replace(reTrim, '');
					var isBinary = reIsBinary.test(value);
					return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
				}
	
				module.exports = debounce;
	
				/***/
			},
			/* 4 */
			function (module, exports) {
	
				module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpCRkNDMzg4M0FFN0IxMUU0OTE2RkY5MzYyMkI3QTVDMiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpCRkNDMzg4NEFFN0IxMUU0OTE2RkY5MzYyMkI3QTVDMiI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkJGQ0MzODgxQUU3QjExRTQ5MTZGRjkzNjIyQjdBNUMyIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkJGQ0MzODgyQUU3QjExRTQ5MTZGRjkzNjIyQjdBNUMyIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+NkztvAAAAc9JREFUeNq8lk8oBFEcx2fG5k+0HJRQ/iVy2U1tUsjBzYnI2cUWJyl3XJRSkgOtxEU4keLgQP6kuColoeQgEkXWand8X/3UNM28Z56Z961PO2/fb9535r3f/N7TTdPUnBSLxTSBcsEA6AW1IAw+wD3YAtPg0+1mXdK4DJyAKk7MM+gE506dhuZdleBSYMpUDM5Ah1NnyKOpDnZpWn91C/ZBksZrBhFL/zaopyWQNh4HDZZ2AsQd4kbBFF3ngRnQ8581vgHVdH0M2jgPeWjpz1BePMqscdRiyrQhiF+25VK7bHI12toXgvg9+yTKGpc6TDtPD+DJ0i6RNS6ytZOC+IwtpkA2q1epKLyDb/D2h3uGQQXIBqcyWd1FBeEOZNFM1YEckHYpTGzgKyqbpmWp1kEq9IeCcQRaNP80CZoMQclb8NmUqRys8IxZpenTglHUEOxAhQEZ5/OM01qAMnwah+3Ng2BTpTGr2a1gHnSDCVXGs7Z2QpVxjUNSKjGeo29T+RuHqaRqtOdGVGZ1in6/VH9OYZet01Uhnx5qBLyAIT+MvVQulslLflWuazq+BKFXnvEaWAzI+IA31ezUMEaJE6dDQYb+9yrdMrs7oP9HgAEAXmVa5ulD/g0AAAAASUVORK5CYII=";
	
				/***/
			}
			/******/])
		);
	});
	;
	/***/ /***/ /***/ /***/ /***/

/***/ },
/* 4 */
/*!************************************!*\
  !*** ./demo/src/vendor/github.css ***!
  \************************************/
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 5 */
/*!**************************************!*\
  !*** ./demo/src/vendor/skeleton.css ***!
  \**************************************/
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 6 */
/*!************************************!*\
  !*** ./demo/src/vendor/syntax.css ***!
  \************************************/
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 7 */
/*!***************************************!*\
  !*** ./~/normalize.css/normalize.css ***!
  \***************************************/
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 8 */
/*!********************************!*\
  !*** ./demo/src/css/demo.scss ***!
  \********************************/
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 9 */
/*!*********************************!*\
  !*** ./demo/src/css/style.scss ***!
  \*********************************/
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** demo.bundle.js
 **/